import React, { Component } from "react";
import CapabilityContextProvider from "../overview/context/CapabilityContext";
import OutboundFilterContextProvider from "../outboundAmzl/context/OutboundFilterContext";
import OutboundConfigContextProvider from "../outboundAmzl/context/OutboundConfigContext";
import RouteContextProvider from "../outboundAmzl/context/RouteContextProvider";
import CycleFilterContextProvider from "../overview/context/CycleFilterContext";
import PVAOverviewContextProvider from "../overview/context/PVAOverviewContext";
import OverviewContextProvider from "../overview/context/OverviewContext";
import OverallStatusContextProvider from "../overallstatus/context/OverallStatusContext";
import PageHeader from "../PageHeader";
import { PAGE_HEADERS } from "../util/Constants";

import OutboundFilter from "../outboundAmzl/OutboundFilter";
import WaveViewSelector from "../outboundAmzl/routegridview/WaveViewSelector";

import OutboundOverviewARV2View from "./OutboundOverviewARV2View";
import RouteGridViewARV2 from "./routegridview/RouteGridViewARV2";

class OutboundOverviewARV2 extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <OutboundFilterContextProvider>
          <OutboundConfigContextProvider>
            <CycleFilterContextProvider>
              <PVAOverviewContextProvider>
                <OverviewContextProvider>
                  <OverallStatusContextProvider>
                    <RouteContextProvider>
                      <PageHeader {...PAGE_HEADERS.OUTBOUND_ARV2} />
                      <OutboundFilter />
                      <OutboundOverviewARV2View />
                      <WaveViewSelector />
                      <RouteGridViewARV2 />
                    </RouteContextProvider>
                  </OverallStatusContextProvider>
                </OverviewContextProvider>
              </PVAOverviewContextProvider>
            </CycleFilterContextProvider>
          </OutboundConfigContextProvider>
        </OutboundFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default OutboundOverviewARV2;



// WEBPACK FOOTER //
// ./src/components/outboundARv2/OutboundOverviewARV2.js